import React from "react";
import DatePicker from "react-datepicker";
import TextareaAutosize from "react-textarea-autosize";
import "react-datepicker/dist/react-datepicker.css";

import classes from "./Input.module.scss";

const Input = ({
  id,
  elementType,
  elementConfig,
  value,
  changed,
  required,
  width,
}) => {
  let inputElement = null;
  const inputClasses = [classes.input];

  switch (elementType) {
    case "input":
      const isFile = elementConfig.type === "file";

      inputElement = (
        <input
          // Add a specific class if it's a file to handle the height/padding
          className={`${classes.input} ${isFile ? classes.fileInput : ""}`}
          {...elementConfig}
          {...(!isFile && { value: value })}
          onChange={changed}
          id={id}
          name={id}
          required={required ? true : null}
          style={{ width: width ? width : "100%" }}
        />
      );
      break;
    case "date":
      inputElement = (
        <div>
          <DatePicker
            {...elementConfig}
            selected={value}
            onChange={changed}
            required={required ? true : null}
            name={elementConfig.placeholder}
          />
        </div>
      );
      break;
    case "textarea":
      inputElement = (
        <TextareaAutosize
          className={classes.input}
          {...elementConfig}
          value={value}
          onChange={changed}
          name={elementConfig.placeholder}
          required={required ? true : null}
          style={{ width: width ? width : "100%" }}
        />
      );
      break;
    case "image":
      inputElement = (
        <>
          {/* Use Optional Chaining (?.) to safely check for the url */}
          {elementConfig?.url ? (
            <img src={elementConfig.url} className={classes.image} alt="" />
          ) : null}
          <input
            type="file"
            className={`${classes.input} `}
            {...elementConfig}
            name={elementConfig?.placeholder || "image"} // Safety check here too
            id="image"
            onChange={changed}
            required={required ? true : null}
            style={{ width: width ? width : "100%" }}
          />
        </>
      );
      break;
    case "select":
      inputElement = (
        <select
          className={inputClasses.join(" ")}
          value={value}
          onChange={changed}
          multiple={elementConfig.multiple}
          style={{ width: width ? width : "100%" }} // Keep styling consistency
        >
          {elementConfig.options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    // case "richtext":
    //   inputElement = (
    //     // <QuillComponent value={value} setValue={changed} {...elementConfig} />
    //     // <ReactQuill
    //     //   theme="snow"
    //     //   value={value}
    //     //   onChange={changed}
    //     //   {...elementConfig}
    //     //   name={elementConfig.placeholder}
    //     // />
    //     // <SlateComponent value />
    //     // <Tiptap />
    //   );
    default:
      break;
  }

  return (
    <div className={classes.inputGroup}>
      {inputElement}
      <label
        htmlFor={id || elementConfig?.placeholder || elementType}
        className={classes.label}
      >
        {elementConfig?.placeholder ||
          elementType.charAt(0).toUpperCase() + elementType.slice(1)}
      </label>
    </div>
  );
};

export default Input;
